

export const SHOULD_SHOW_SEARCH_BAR = 'SHOULD_SHOW_SEARCH_BAR'
export const UPDATE_SEARCH_WORD = 'UPDATE_SEARCH_WORD'
export const UPDATE_TITLE = 'UPDATE_TITLE'
export const GET_COMPANIES_INFO_SUCCESS = "GET_COMPANIES_INFO_SUCCESS"
export const SET_CURRENT_COMPANY = "SET_CURRENT_COMPANY"
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS"
export const GET_REALTORS_DATA_SUCCESS = "GET_REALTORS_DATA_SUCCESS"
export const GET_POINTS_FOR_REALTOR_SUCCESS = "GET_POINTS_FOR_REALTOR_SUCCESS"
export const UPDATE_SELECTED_REALTOR_INFO = "UPDATE_SELECTED_REALTOR_INFO"
export const GET_NOTIFICATIONS_DATA_SUCCESS = "GET_NOTIFICATIONS_DATA_SUCCESS"
export const DELETE_NOTIFICATION_SUCCESS = "DELETE_NOTIFICATION_SUCCESS"
export const DELETE_NOTIFICATION_FROM_STATE = "DELETE_NOTIFICATION_FROM_STATE"
export const CLEAR_SELECTED_REALTOR_POINTS = "CLEAR_SELECTED_REALTOR_POINTS"
export const GET_ALL_COMMUNITIES_SUCCESS = "GET_ALL_COMMUNITIES_SUCCESS"
export const GET_ALL_REGIONS_SUCCESS = "GET_ALL_REGIONS_SUCCESS"
export const GET_ALL_REWARDS_SUCCESS = "GET_ALL_REWARDS_SUCCESS"
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS"
export const GET_ALL_ON_HOLD_POINTS_SUCCESS = "GET_ALL_ON_HOLD_POINTS_SUCCESS"
export const GET_ALL_CLIENT_REGISTRATIONS_SUCCESS = "GET_ALL_CLIENT_REGISTRATIONS_SUCCESS"
export const GET_POINTS_SUCCESS = "GET_POINTS_SUCCESS"
export const GET_MY_POINTS_SUCCESS = "GET_MY_POINTS_SUCCESS"
export const GET_MY_SUBMITTED_POINTS_SUCCESS = "GET_MY_SUBMITTED_POINTS_SUCCESS"
export const GET_ALL_MANAGERS_SUCCESS = "GET_ALL_MANAGERS_SUCCESS"
export const SET_MANAGER_FOR_USER = "SET_MANAGER_FOR_USER"
export const SET_REGION_FOR_USER = "SET_REGION_FOR_USER"
export const BEGIN_API_CALL = "BEGIN_API_CALL"
export const API_CALL_ERROR = "API_CALL_ERROR"
export const ZERO_OUT_API_CALLS = "ZERO_OUT_API_CALLS"
export const UPDATE_SUBMIT_ON_CLIENT_REGISTRATION = "UPDATE_SUBMIT_ON_CLIENT_REGISTRATION"
export const GET_ALL_CLIENT_REGISTRATION_STUFF = "GET_ALL_CLIENT_REGISTRATION_STUFF"
export const GET_ALL_SALES_SUCCESS = "GET_ALL_SALES_SUCCESS"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const DELETE_COMMUNITY_SUCCESS = "DELETE_COMMUNITY_SUCCESS"
export const UPDATE_COMMUNITY_SUCCESS = "UPDATE_COMMUNITY_SUCCESS"
export const DELETE_REGION_SUCCESS = "DELETE_REGION_SUCCESS"
export const UPDATE_REWARDS_SUCCESS = "UPDATE_REWARDS_SUCCESS"
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const REALTOR_POINT_APPROVAL = "REALTOR_POINT_APPROVAL"
export const REALTOR_POINT_DENY = "REALTOR_POINT_DENY"
export const REALTOR_POINT_DELETE = "REALTOR_POINT_DELETE"
export const POINTS_POINT_APPROVAL = "POINTS_POINT_APPROVAL"
export const POINTS_POINT_DENY = "POINTS_POINT_DENY"
export const POINTS_POINT_DELETE = "POINTS_POINT_DELETE"
export const MY_POINTS_POINT_APPROVAL = "MY_POINTS_POINT_APPROVAL"
export const MY_POINTS_POINT_DENY = "MY_POINTS_POINT_DENY"
export const MY_POINTS_POINT_DELETE = "MY_POINTS_POINT_DELETE"
export const MY_SUBMITTED_POINTS_POINT_APPROVAL = "MY_SUBMITTED_POINTS_POINT_APPROVAL"
export const MY_SUBMITTED_POINTS_POINT_DENY = "MY_SUBMITTED_POINTS_POINT_DENY"
export const MY_SUBMITTED_POINTS_POINT_DELETE = "MY_SUBMITTED_POINTS_POINT_DELETE"
export const DELETE_ON_HOLD_POINTS_SUCCESS = "DELETE_ON_HOLD_POINTS_SUCCESS"
export const GET_NOTIFICATION_ANALYTICS_SUCCESS = "GET_NOTIFICATION_ANALYTICS_SUCCESS"
export const SHOULD_SET_USERS_TO_SELECTED = "SHOULD_SET_USERS_TO_SELECTED"
export const SET_ALL_USERS_FOR_SELECTION = "SET_ALL_USERS_FOR_SELECTION"
export const SET_CURRENT_COMPANY_TO_EMPTY = "SET_CURRENT_COMPANY_TO_EMPTY"
export const DELETE_REWARDS_SUCCESS = "DELETE_REWARDS_SUCCESS"
export const CREATE_REWARDS_SUCCESS = "CREATE_REWARDS_SUCCESS"
export const UPDATE_CURRENT_COMPANY = "UPDATE_CURRENT_COMPANY"
export const GET_ALL_AUTO_NOTIFICATION_SUCCESS = "GET_ALL_AUTO_NOTIFICATION_SUCCESS"
export const DELETE_AUTO_NOTIFICATION_SUCCESS = "DELETE_AUTO_NOTIFICATION_SUCCESS"
export const CREATE_AUTO_NOTIFICATION_SUCCESS = "CREATE_AUTO_NOTIFICATION_SUCCESS"
export const UPDATE_AUTO_NOTIFICATION_SUCCESS = "UPDATE_AUTO_NOTIFICATION_SUCCESS"
export const GET_ALL_BONUS_LEVELS_SUCCESS = "GET_ALL_BONUS_LEVELS_SUCCESS"
export const UPDATE_BONUS_LEVELS_SUCCESS = "UPDATE_BONUS_LEVELS_SUCCESS"
export const UPDATE_CURRENT_COMPANY_SHOULD_USE_BONUS_LEVELS = "UPDATE_CURRENT_COMPANY_SHOULD_USE_BONUS_LEVELS"
export const GET_EVENTS_INFO_FOR_USER_SUCCESS = "GET_EVENTS_INFO_FOR_USER_SUCCESS"
export const SHOULD_SET_USERS_TO_SELECTED_FOR_EVENT = "SHOULD_SET_USERS_TO_SELECTED_FOR_EVENT"
export const SET_ALL_USERS_FOR_EVENT_SELECTION = "SET_ALL_USERS_FOR_EVENT_SELECTION"
export const GET_EVENT_ANALYTICS_SUCCESS = "GET_EVENT_ANALYTICS_SUCCESS" 


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js